export const BASE_URL = (process.env.NODE_ENV === 'development')? 'https://ninja-dev-server.herokuapp.com/' : 'https://ninja-dev-server.herokuapp.com/'
export const LOGIN_URL = BASE_URL + 'auth/login'
export const SIGNUP_URL = BASE_URL + 'auth/signup'
export const CHAT_URL = BASE_URL + 'cuchat/chats'

/**
 *  url: http://localhost:5000/
 */